import { useQuery } from '@tanstack/react-query';
import { queries } from '../../../../../shared/queries';
import { handleError } from '../../../../ui/err/handleError';
import { AxiosError } from 'axios';
import { AxiosCommonError } from '../../../../../shared/types';
import { prodoqPermissionStore } from '../../../../../shared/store/prodoqPermission.store';

interface UseGetPermissionsParams {
  companyId: number;
  enabled: boolean;
}

export default function useGetPermissions(params: UseGetPermissionsParams) {
  const setPermissionData = prodoqPermissionStore((state) => state.setPermissionData);

  const query = useQuery({
    ...queries.prodoq.permissions({ companyId: params.companyId }),
    enabled: params.enabled,
    select: (data) => data.data,
    onSuccess: (data) => {
      setPermissionData({
        companyId: params.companyId,
        menus: data.menus,
        roles: data.roles,
      });
    },
    onError: (error: AxiosError<AxiosCommonError>) => {
      handleError(error);
    },
  });

  return query;
}
